import React from "react";
import { motion } from "framer-motion";
import { MaskLines } from "./motion";
import { CourtLines, MonoTag } from "./motifs";

// Theme-aware editorial hero used by inner pages (colors come from MiniSite CSS vars)
export const PageHero = ({ overline, code, title, subtitle, image }) => (
  <section className="relative pt-32 md:pt-44 pb-16 md:pb-24 overflow-hidden grain">
    {image && (
      <div className="absolute inset-0">
        <img src={image} alt="" className="w-full h-full object-cover opacity-25" />
        <div className="absolute inset-0" style={{ background: "linear-gradient(to top, var(--ms-bg, #060B14) 8%, transparent 95%)" }} />
      </div>
    )}
    <CourtLines className="-right-56 -top-56 w-[640px] h-[640px] hidden md:block" />
    <div className="relative z-10 max-w-[1400px] mx-auto px-5 md:px-10">
      <div className="flex flex-wrap items-center gap-3 mb-6">
        {code && (
          <MonoTag className="border border-white/25 rounded-full px-3 py-1.5 text-white/70">{code}</MonoTag>
        )}
        {overline && <MonoTag style={{ color: "var(--ms-accent, #E5352B)" }}>{overline}</MonoTag>}
      </div>
      <MaskLines lines={Array.isArray(title) ? title : [title]}
        className="font-display uppercase leading-[0.85] text-white text-5xl sm:text-6xl lg:text-8xl tracking-tight" />
      {subtitle && (
        <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.5 }}
          className="font-body text-white/70 max-w-2xl mt-8 text-base md:text-lg">
          {subtitle}
        </motion.p>
      )}
    </div>
  </section>
);
